import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";
import { redirectAuthenticatedUser } from "../../router/auth";
import { resolveAuthenticationReturnTo } from "../../router/auth-return-intent";

const Screen = lazy(() => import("../../views/auth/SignIn/EmailSignIn"));

export const Route = createFileRoute("/_public/sign-in_/email")({
  component: RouteComponent,
  beforeLoad: redirectAuthenticatedUser,
  validateSearch: (search: Record<string, unknown>) => ({
    redirectUrl:
      search.redirectUrl === undefined
        ? undefined
        : resolveAuthenticationReturnTo(search.redirectUrl),
  }),
  staticData: {
    routeKey: "signInEmail",
    access: "public-auth",
    layout: "modern",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
